module.exports = __webpack_public_path__ + "img/dress.296dfa45.webp";